// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"ccf1d61e","527":"00fe0b7e"}[chunkId] + ".chunk.js";
};